export const BODY_TEXT =
  'Tax impact details are not currently available. ' +
  'Please note that proceeding with this transaction may have tax consequences, ' +
  'or you can try again later to see your estimated tax impact.';

export const BUY_ORDER_COPY = {
  header: 'Tax impact',
  body: BODY_TEXT,
};

export const SELL_ORDER_COPY = {
  header: 'Estimated taxes owed',
  body: BODY_TEXT,
};
